import { useParams } from "react-router";
import { useAppDispatch, useAppSelector } from "../../../hooks/app";
import { useEffect, useState } from "react";
import { StatusEnum } from "../../../commons/enums/status-enum";
import { AppBox, AppContainer, AppModal, NotFound } from "../../../commons/components";
import FootballOrganizerManageDetailHeader from "./components/OrganizerManageDetailHeader";
import FootballOrganizerAddEdit from "./components/organizerAddEdit/OrganizerAddEdit";
import FootballOrganizerInfo from "./components/OrganizerInfo";
import { setPageTitle } from "../../../redux/slices/page-title-slice";
import IconEdit from "../../../commons/components/icons/edit";
import { cleanUpStepperFormData } from "../../../redux/slices/stepper-form-slice";
import {
  cleanUpFootballOrganizerInfo,
  fetchFootballOrganizer,
} from "../../../redux/slices/football/admin/organizer/manage-football-organizer-slice";

export default function FootballOrganizerDetailManage() {
  const { organizerId } = useParams();
  const dispatch = useAppDispatch();
  const [isEditFootballOrganizer, setIsEditFootballOrganizer] = useState(false);
  const { footballOrganizerInfo, footballOrganizerInfoStatus } = useAppSelector(
    (state) => state.manageFootballOrganizer
  );
  const { footballOrganizerEditStatus } = useAppSelector((state) => state.manageFootballOrganizerEdit);
  useEffect(() => {
    dispatch(fetchFootballOrganizer(Number(organizerId)));
  }, [organizerId]);

  useEffect(() => {
    if (footballOrganizerInfoStatus === StatusEnum.Failed) {
      return () => {
        dispatch(cleanUpFootballOrganizerInfo());
      };
    }
  }, [footballOrganizerInfoStatus]);

  useEffect(() => {
    dispatch(setPageTitle(""));
    return () => {
      dispatch(cleanUpFootballOrganizerInfo());
    };
  }, []);

  const handleAfterEdit = () => {
    setIsEditFootballOrganizer(false);
    dispatch(fetchFootballOrganizer(Number(organizerId)));
  };

  const handleAfterEditClose = () => {
    setIsEditFootballOrganizer(false);
    dispatch(cleanUpStepperFormData());
  };

  return (
    <AppContainer>
      {footballOrganizerInfoStatus === StatusEnum.Failed ? (
        <NotFound />
      ) : (
        <AppBox mt="md" flexDirection="column" gap="md">
          <FootballOrganizerManageDetailHeader
            footballOrganizer={footballOrganizerInfo}
            onEditFootballOrganizer={() => setIsEditFootballOrganizer(true)}
          />
          <FootballOrganizerInfo footballOrganizerInfo={footballOrganizerInfo} />
        </AppBox>
      )}
      <AppModal
        opened={isEditFootballOrganizer}
        modalSize="lg"
        onClose={handleAfterEditClose}
        title="Edit Venue"
        titleIcon={<IconEdit />}
        withLoadingButton={footballOrganizerEditStatus === StatusEnum.Loading}
        withoutButtons
      >
        <FootballOrganizerAddEdit
          footballOrganizerData={footballOrganizerInfo}
          onCancel={handleAfterEditClose}
          onSave={handleAfterEdit}
        />
      </AppModal>
    </AppContainer>
  );
}
